import {
  ChangeEvent,
  memo, ReactElement, useCallback,
} from 'react';
import cn from 'classnames';
import { createUseStyles } from 'react-jss';

type MultilineInputProps = {
  label?: string,
  value?: string,
  onChange?: (event: string) => void,
  className?: string,
};

const MultilineInput = (props: MultilineInputProps): ReactElement => {
  const {
    label, value, onChange, className,
  } = props;

  const classes = useClasses();

  const handleChange = useCallback((event: any) => {
    onChange?.(event.target.value);
  }, [onChange]);

  return (
    <div className={cn(classes.MultilineInput, className)}>
      {label && (
        <div className={classes.label}>{label}</div>
      )}
      <textarea className={classes.multilineInput} value={value} onChange={handleChange} />
    </div>
  );
};

const useClasses = createUseStyles({
  MultilineInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    color: '#454545',
    minHeight: '10rem',
  },
  label: {
    fontWeight: 500,
    fontSize: '1.5rem',
    color: '#3F3F3F',
    marginBottom: '0.8rem',
  },
  multilineInput: {
    fontWeight: 500,
    fontSize: '1.5rem',
    borderRadius: '0.7rem',
    boxShadow: '1px 2px 5px rgba(0, 0, 0, 0.05)',
    background: '#ffffff',
    padding: '1.2rem 1.6rem',
    border: 0,
    color: '#3F3F3F',
    resize: 'none',
    flex: 1,
  },
});

export default memo(MultilineInput);
